import { createContext, JSX, ReactNode, useContext, useState } from 'react';
import { usePortalBranding, PortalBranding, SSOType } from 'vopay';

type SsoProviders = Partial<Record<SSOType, boolean>>;

type BrandingCtx = PortalBranding & {
  // Missing provider entries mean "enabled" so older backends keep showing all SSO buttons
  ssoProviders: SsoProviders;
  setSsoProviders: (providers: SsoProviders) => void;
};

export const BrandingContext = createContext<BrandingCtx>({
  primaryColor: '',
  secondaryColor: '',
  logo: '',
  smallLogo: '',
  appTitle: '',
  defaultPrimaryColor: '',
  defaultSecondaryColor: '',
  setBrandingValues: () => {},
  ssoProviders: {},
  setSsoProviders: () => {},
});

type BrandingProviderProps = {
  children: ReactNode;
};

export const BrandingContextProvider = ({ children }: BrandingProviderProps): JSX.Element => {
  const portalBranding = usePortalBranding('VoPay Account Portal');
  const [ssoProviders, setSsoProviders] = useState<SsoProviders>({});

  return (
    <BrandingContext.Provider value={{ ...portalBranding, ssoProviders, setSsoProviders }}>
      {children}
    </BrandingContext.Provider>
  );
};

export const useBranding = () => useContext(BrandingContext);
